import { COMPANY } from "@/data/site";

export default function TopBar() {
  return (
    <aside
      data-testid="top-credentials-bar"
      className="bg-[#1e3a8a] text-white py-2 px-6 text-xs uppercase tracking-widest font-semibold flex flex-wrap justify-between items-center gap-2 border-b border-[#172554]"
    >
      <div className="flex items-center gap-4">
        <span className="inline-block w-2 h-2 rounded-full bg-emerald-400" aria-hidden="true" />
        <span data-testid="topbar-gst">GSTIN: {COMPANY.gst}</span>
        <span className="hidden md:inline text-blue-200">|</span>
        <span className="hidden md:inline text-blue-100">Specialist Italian Mirror Polish &amp; Crack Repair</span>
      </div>
      <div className="flex items-center gap-6 text-blue-100">
        <a data-testid="topbar-phone-link" href={`tel:${COMPANY.phone1Raw}`} className="hover:text-white transition-colors">
          Mumbai: +91 9867439947 / 7977988876
        </a>
        <span className="hidden sm:inline" data-testid="topbar-base">{COMPANY.base}</span>
      </div>
    </aside>
  );
}
